import React, { useEffect, useMemo, useState } from 'react';
import { normalizeHistoryStorage, getHistoryToken, filterHistoryTokens } from '../components/utilsDesign';
import { getLocal, getLocalBool, setLocal } from '../components/utilsSocial';
import {
  applyUiTheme,
  bindSystemThemeListener,
  getUiThemePreference,
  setUiThemePreference,
  UI_THEME_SYSTEM,
} from '../components/theme';

export const PAGINATE_DEFAULT = 120;

const StateContext = React.createContext();


function StateProvider({ children }) {

  //PROD
  const [data, setData] = useState([])
  const [svgs, setSvgs] = useState([])
  const [preloadPage, setPreloadPage] = useState('');
  const [loading, setLoading] = useState(false);
  const [addPop, setAddPop] = useState(false);
  const [peoplePanel, showPeoplePanelInner] = useState(false);
  const [pentaChooseId, setPentaChooseId] = useState(false);
  const [groupChooseId, setGroupChooseId] = useState(false);
  const [citySearchActive, setCitySearchActive] = useState(false);
  const [currentUser, setCurrentUser] = useState();
  const [firstPage, setFirstPage] = useState();
  const [activePage, setActivePage] = useState();
  const [importedId, setImportedId] = useState();
  const [composite, setComposite] = useState([]);
  const [search, setSearch] = useState([]);
  const [highlighted, setHighlighted] = useState([]);
  const [calcShown, setCalcShownInner] = useState(false);
  const [currentPeopleSet, setCurrentPeopleSet] = useState(['people']);
  const [cityPeople, setCityPeople] = useState([]);


  const showPeoplePanel = (val) => {
    if (val && calcShown) {setCalcShown(false)}
    showPeoplePanelInner(val)
  }

  const choosePenta = (pentaToken) => {
    if (!peoplePanel) showPeoplePanel(['pentas']);
    setPentaChooseId(pentaToken);
  }

  const chooseGroup = (groupId) => {
    setGroupChooseId(groupId);
  }


  const [faqShown, setFaqShown] = useState(false);
  const [authModal, setAuthModal] = useState(false);




  const [tryDesignDate, setTryDesignDate] = useState();

  const setCalcShown = (val) => {
    if (!val) {
      setCalcShownInner(false)
      setCitySearchActive(false)
    }
    if (val) setCalcShownInner(true)
  }

  const [showHistory, setShowHistoryInner] = useState(() => {
    const raw = getLocal('showHistory');
    return raw != null && raw !== '' && raw !== 'false' ? normalizeHistoryStorage(raw) : [];
  })
  const [selectByType, setSelectByType] = useState(getLocalBool('selectByType', true));
  const [selectByProfile, setSelectByProfile] = useState(getLocalBool('selectByProfile', true));
  const [selectByChannel, setSelectByChannel] = useState(getLocalBool('selectByChannel', false));
  const [selectByAuthority, setSelectByAuthority] = useState(getLocalBool('selectByAuthority', false));
  const [selectByVariable, setSelectByVariable] = useState(getLocalBool('selectByVariable', false));
  const [selectByCross, setSelectByCross] = useState(getLocalBool('selectByCross', false));
  const [selectByEnvironment, setSelectByEnvironment] = useState(getLocalBool('selectByEnvironment', false));
  const [sort, setSort] = useState(getLocal('sort') ? getLocal('sort') : 'profiles'); //profiles,channels,gates,emg
  const [namesHidden, setNamesHidden] = useState(getLocalBool('namesHidden', false));
  const [bodygraphChooseSimple, setBodygraphChooseSimple] = useState(getLocalBool('bodygraphChooseSimple', false));
  const [emgStat, setEmgStat] = useState(getLocalBool('emgStat', false));
  // const [png, setPng] = useState(getLocalBool('png', true));
  const [png, setPng] = useState(getLocalBool('png', true));
  const [mode3d, setMode3d] = useState(getLocalBool('mode3d', false));
  const [narrativeBeta, setNarrativeBeta] = useState(getLocalBool('narrativeBeta', false));
  const [version, setVersion] = useState(getLocal('version') ? getLocal('version') : '.');
  const [compareWith, setCompareWith] = useState(getLocal('compareWith') ? getLocal('compareWith') : 'celebs');
  const [colorMode, setColorMode] = useState(getLocal('colorMode') ? getLocal('colorMode') : 'colorsClassic');
  const [uiTheme, setUiThemeState] = useState(() => getUiThemePreference() || UI_THEME_SYSTEM);

  const setUiTheme = (next) => {
    const pref = setUiThemePreference(next);
    setUiThemeState(pref);
    applyUiTheme(pref);
  };

  const [paginate, setPaginate] = useState(() => {
    const stored = parseInt(getLocal('paginate'), 10);
    return stored > 0 ? stored : PAGINATE_DEFAULT;
  });
  const [astroShown, setAstroShown] = useState(getLocalBool('astroShown', true));
  const [numeroShown, setNumeroShown] = useState(getLocalBool('numeroShown', false));
  const [jyotishShown, setJyotishShown] = useState(getLocalBool('jyotishShown', false));
  const [varnaBy, setVarnaBy] = useState(getLocal('varnaBy') ? getLocal('varnaBy') : 'nakshatra');
  const [groupsShown, setGroupsShown] = useState(getLocalBool('groupsShown', false));
  const [pentaFolders, setPentaFolders] = useState(getLocalBool('pentaFolders', false));
  const [supportShown, setSupportShown] = useState(getLocalBool('supportShown', false));

  const [hideNames, setHideNames] = useState(getLocalBool('hideNames', false));


  const setShowHistory = (tokenOrEntry, del, all, keepToken) => {
    const limit = 12;

    if (all) {
      setShowHistoryInner(prev => keepToken ? prev.filter(token => token === keepToken) : []);
      return;
    }

    if (del) {
      const toRemove = new Set(
        (Array.isArray(tokenOrEntry) ? tokenOrEntry : [tokenOrEntry])
          .map(getHistoryToken)
          .filter(Boolean)
      );
      if (!toRemove.size) return;
      setShowHistoryInner(prev => prev.filter(t => !toRemove.has(t)));
      return;
    }

    if (Array.isArray(tokenOrEntry)) {
      const normalized = normalizeHistoryStorage(tokenOrEntry).slice(0, limit);
      setShowHistoryInner(prev => {
        if (prev.length === normalized.length && prev.every((t, i) => t === normalized[i])) {
          return prev;
        }
        return normalized;
      });
      return;
    }

    const token = getHistoryToken(tokenOrEntry);
    if (!token) return;

    setShowHistoryInner(prev => {
      let newHistory = prev.filter(t => t !== token);
      newHistory = [token, ...newHistory];
      if (newHistory.length > limit) {
        newHistory = newHistory.slice(0, limit);
      }
      return newHistory;
    });
  };







  useEffect(() => {
    applyUiTheme(uiTheme);
    bindSystemThemeListener();
  }, []);

  useEffect(() => {
    if (citySearchActive) {
      document.body.classList.add('noscroll');
    } else {
      document.body.classList.remove('noscroll');
    }
  }, [citySearchActive])

  useEffect(() => {
    // console.log('highlighted = ', highlighted);
  }, [highlighted])

  useEffect(() => {
    // console.log('search = ', search);
  }, [search])


  useEffect(() => {
    setLocal('showHistory', filterHistoryTokens(showHistory))
    setLocal('png', png)
    setLocal('mode3d', mode3d)
    setLocal('bodygraphChooseSimple', bodygraphChooseSimple)
    setLocal('narrativeBeta', narrativeBeta)
    setLocal('selectByType', selectByType)
    setLocal('selectByProfile', selectByProfile)
    setLocal('selectByChannel', selectByChannel)
    setLocal('selectByAuthority', selectByAuthority)
    setLocal('selectByVariable', selectByVariable)
    setLocal('selectByCross', selectByCross)
    setLocal('selectByEnvironment', selectByEnvironment)
    setLocal('sort', sort)
    setLocal('emgStat', emgStat)
    setLocal('namesHidden', namesHidden)
    setLocal('version', version)
    setLocal('compareWith', compareWith)
    setLocal('colorMode', colorMode)
    setLocal('uiTheme', uiTheme)
    setLocal('astroShown', astroShown)
    setLocal('numeroShown', numeroShown)
    setLocal('jyotishShown', jyotishShown)
    setLocal('paginate', paginate)
    setLocal('varnaBy', varnaBy)
    setLocal('groupsShown', groupsShown)
    setLocal('pentaFolders', pentaFolders)
    setLocal('supportShown', supportShown)
  }, [
    showHistory,
    png,
    mode3d,
    bodygraphChooseSimple,
    narrativeBeta,
    selectByType,
    selectByProfile,
    selectByChannel,
    selectByAuthority,
    selectByVariable,
    selectByCross,
    selectByEnvironment,
    sort,
    emgStat,
    namesHidden,
    version,
    compareWith,
    colorMode,
    uiTheme,
    astroShown,
    numeroShown,
    jyotishShown,
    paginate,
    varnaBy,
    groupsShown,
    pentaFolders,
    supportShown
  ])


  const [rectificationDesigns, setRectificationDesigns] = useState({})

  const checkRangeDesign = (token, min, max) => {
    // min = min.replace('T', '').replace('.000Z', '')
    // max = max.replace('T', '').replace('.000Z', '')
    min = min.replace('.000Z', '')
    max = max.replace('.000Z', '')
    if (rectificationDesigns[token][min] && rectificationDesigns[token][max]) {
      return true
    }
    return false
  }

  // useEffect(() => {
  //   console.log('rectificationDesigns = ', rectificationDesigns);
  // }, [rectificationDesigns])


  const value = useMemo(() => ({
    state: {
      rectificationDesigns,
      citySearchActive,
      addPop,
      namesHidden,
      highlighted,
      peoplePanel,
      pentaChooseId,
      groupChooseId,
      activePage,
      currentUser,
      firstPage,
      importedId,
      showHistory,
      narrativeBeta,
      loading,
      composite,
      preloadPage,
      svgs,
      colorMode,
      uiTheme,
      png,
      mode3d,
      bodygraphChooseSimple,
      selectByType,
      selectByProfile,
      selectByChannel,
      selectByAuthority,
      selectByVariable,
      selectByCross,
      selectByEnvironment,
      sort,
      emgStat,
      search,
      calcShown,
      version,
      currentPeopleSet,
      cityPeople,
      tryDesignDate,
      hideNames,
      faqShown,
      authModal,
      compareWith,
      paginate,
      astroShown,
      numeroShown,
      jyotishShown,
      varnaBy,
      groupsShown,
      pentaFolders,
      supportShown
    },
    setState: {
      setRectificationDesigns,
      setCitySearchActive,
      setPng,
      setMode3d,
      setShowHistory,
      setHighlighted,
      setAddPop,
      setNamesHidden,
      setBodygraphChooseSimple,
      showPeoplePanel,
      choosePenta,
      setPentaChooseId,
      setGroupChooseId,
      chooseGroup,
      setActivePage,
      setCurrentUser,
      setFirstPage,
      setImportedId,
      setAllData: setData,
      setNarrativeBeta,
      setLoading,
      setComposite,
      setSelectByType,
      setSelectByProfile,
      setSelectByChannel,
      setSelectByAuthority,
      setSelectByVariable,
      setSelectByCross,
      setSelectByEnvironment,
      setSort,
      setEmgStat,
      setPreloadPage,
      setSearch,
      setCalcShown,
      setVersion,
      setCurrentPeopleSet,
      setCityPeople,
      setTryDesignDate,
      setHideNames,
      setFaqShown,
      setAuthModal,
      setCompareWith,
      setColorMode,
      setUiTheme,
      setAstroShown,
      setNumeroShown,
      setJyotishShown,
      setPaginate,
      setVarnaBy,
      setGroupsShown,
      setPentaFolders,
      setSupportShown
    },
    checkRangeDesign
  }), [
    rectificationDesigns, 
    citySearchActive, 
    addPop, 
    namesHidden, 
    highlighted, 
    peoplePanel, 
    pentaChooseId,
    groupChooseId,
    activePage, 
    currentUser, 
    firstPage, 
    importedId, 
    showHistory, 
    narrativeBeta, 
    loading, 
    composite, 
    preloadPage, 
    svgs, 
    colorMode,
    uiTheme,
    png, 
    mode3d,
    bodygraphChooseSimple, 
    selectByType, 
    selectByProfile, 
    selectByChannel, 
    selectByAuthority, 
    selectByVariable, 
    selectByCross, 
    selectByEnvironment, sort, emgStat, search, calcShown, version, currentPeopleSet, cityPeople, tryDesignDate, hideNames, faqShown, authModal, compareWith, astroShown, numeroShown, 
    jyotishShown, 
    paginate, 
    varnaBy,
    groupsShown,
    pentaFolders,
    supportShown]);



  return (<>
    <StateContext.Provider
      value={value}
    >
      {children}
    </StateContext.Provider>
  </>
  )

}

const ContextConsumer = StateContext.Consumer;

export { ContextConsumer, StateContext, StateProvider };
